import React, { useEffect, useState } from 'react';
import { Container } from 'typescript-ioc';
import classnames from 'classnames';

import { IGetMeetingsRequestParams, IMeetingsDAO } from '../../../api/meetings.dao';
import { DefaultSpinner } from '../spinner/default-spinner';
import OECheckbox from '../oe-checkbox/oe-checkbox';

import './single-selection-dropdown.scss';
import Text from '../text/text';
import { IGNORE_ATTENDEES } from '../../../api/organizations.dao';

export interface IProp {
    accountId: number;
    eventId: number;
    entityName: string;
    onApply: (param: boolean) => void;
    classNames?: string | null;
    withoutRoom: boolean;
}

const SingleSelectionDropdown = (props: IProp) => {
    const { accountId, eventId, entityName, classNames, onApply, withoutRoom } = props;
    const meetingsDAO = Container.get(IMeetingsDAO);

    const [isOpen, toggleOption] = useState(false);
    const [isFetching, setFetching] = useState(false);
    const [checkedItem, setCheckedItem] = useState(false);
    const [haveItems, setHaveItems] = useState(false);

    useEffect(() => {
        if (!withoutRoom) {
            setHaveItems(false);
        }
        setCheckedItem(withoutRoom);
    }, [withoutRoom]);

    const fetchItems = () => {
        setFetching(true);
        const params = {
            accountId: accountId,
            eventId: eventId,
            withoutRoom: true,
            ignoreRegistrants: IGNORE_ATTENDEES,
        };

        meetingsDAO.getEventMeetings(params as IGetMeetingsRequestParams).then(data => {
            setHaveItems(data.content.length > 0);
            setFetching(false);
        });
    };

    const onDropdownClick = () => {
        toggleOption(prev => !prev);

        if (!isOpen) {
            fetchItems();
        }
    };

    const onChangeOption = () => {
        toggleOption(false);
        setCheckedItem(prev => !prev);

        onApply(!checkedItem);
    };

    const noItemsPlaceholder = (
        <div className='multi-selection-dropdown__placeholder'>
            <div>No Meetings found.</div>
            <div>Try adjusting your filter criteria.</div>
        </div>
    );

    return (
        <div className={classnames('single-selection-dropdown multi-selection-dropdown', classNames)}>
            <div
                onClick={onDropdownClick}
                className={classnames('cell-header-btn', {'cell-header-btn--active': isOpen || checkedItem})}
            >
                <Text message={entityName} withEllipsis />
            </div>
            {isOpen &&
            <>
                <div className='multi-selection-dropdown__overlay' onClick={() => toggleOption(false)}/>
                <div className='single-selection-dropdown__options multi-selection-dropdown__options'>
                    {isFetching ?
                        <DefaultSpinner/> :
                        (haveItems ? (
                            <div className='multi-selection-dropdown__list'>
                                <OECheckbox
                                    classNames='multi-selection-dropdown__option'
                                    label='Show Unassigned Meetings'
                                    showAfterLabel={true}
                                    checked={checkedItem}
                                    onChange={onChangeOption}
                                />
                            </div>
                        ) : noItemsPlaceholder)}
                </div>
            </>
            }
        </div>
    );
};

export default SingleSelectionDropdown;